$(document).on('imageLoaded', (_, image) => {
  const $thumbnail = image.$el.closest('.thumbnail')
  const isAllImagesLoaded = $thumbnail
    .find('.image')
    .toArray()
    .every(innerImage => innerImage.classList.contains('is__loaded'))

  if (isAllImagesLoaded) $thumbnail.addClass('is__ready')
})
